export default __webpack_public_path__ + "images/imagite-edit-profile-background.svg";